import { Component, Input, Output, EventEmitter, HostBinding } from '@angular/core';

import { v4 as uuid } from 'uuid';

/**
 * Reusable input-radio component for Angular.
 *
 * This component can be used to display an input radio that can be selected by the user.
 * It can be used independently of the formGroup.
 */

@Component({
  selector: 'fin-input-radio',
  styleUrls: ['input-radio.component.scss'],
  templateUrl: 'input-radio.component.html',
})
export class InputRadioComponent {
  @Input()
  value: string;
  @Input()
  selected: boolean;
  @Input()
  label: string;
  @Input()
  disabled: boolean;
  @Input()
  set name(name: string) {
    this.id = `${name}-${uuid()}`;
    this.inputName = name;
  }

  @HostBinding('class.checkbox-disabled')
  get disabledState(): boolean {
    return this.disabled;
  }

  @Output()
  radioChange: EventEmitter<Event> = new EventEmitter<Event>();

  id: string;
  inputName: string;
}
